import VerifyNewAccount from './VerifyNewAccount.container';
export default VerifyNewAccount;
